import { combineReducers } from '@ngrx/store';
import * as fromTopLocation from './top-location-form.reducer';

export interface TopLocationState {
  topLocationFormState: fromTopLocation.TopLocationFormState;
}

export const reducers = combineReducers({
  topLocationFormState: fromTopLocation.rmsSpecificationFormReducer,
});
